module.exports = __webpack_public_path__ + "static/img/PubMed.09f154f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/PubMed.png
// module id = q3UP
// module chunks = 1